import React, { useEffect } from 'react'

const DbIndex = () => {
  useEffect(() => {
    window.location.href = '/cms'
  }, [])

  return <div />
}

export default DbIndex
